import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Grid, Tooltip, Typography } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

function ModoInsercaoObservacao(props) {
  const {
    filiado,
    salvarNovaObservacao,
    visualizarListagem
  } = props;
  const [novaObservacao, setNovaObservacao] = useState({
    titulo: null,
    descricao: null
  });
  const [erroTitulo, setErroTitulo] = useState(false);
  const [refreshState, setRefreshState] = useState(new Date());

  function aoModificarTitulo(event, valor) {
    event.preventDefault();
    novaObservacao.titulo = valor;
    setNovaObservacao(novaObservacao);
    setRefreshState(new Date());
    if (!valor) {
      setErroTitulo(true);
    }
    else {
      setErroTitulo(false);
    }
  }

  function aoModificarDescricao(event, valor) {
    event.preventDefault();
    if (valor.length < 1500) {
      novaObservacao.descricao = valor;
      setNovaObservacao(novaObservacao);
      setRefreshState(new Date());
    }
  }

  return (
    <Grid
      container
      spacing={2}
    >
      <Grid
        item
        md={2}
        xs={2}
      >
        <Tooltip
          title={'Clique para visualizar as observações do filiado'}
          children={
            <IconButton
              edge="end"
              onClick={e => visualizarListagem(e)}
            >
              <ArrowBackIcon fontSize={'default'}/>
            </IconButton>
          }
        >
        </Tooltip>
      </Grid>
      <Grid
        item
        md={10}
        xs={10}
      >
        <Typography
          variant="h4"
          color="textPrimary"
          gutterBottom
        >
          Nova observação
        </Typography>
      </Grid>
      <Grid
        item
        md={12}
        xs={12}
      >
        <TextField
          fullWidth
          variant={'outlined'}
          inputProps={{ maxLength: 100 }}
          margin={'dense'}
          label={'Título'}
          helperText={'Informe um título para identificar facilmente sua observação.'}
          value={novaObservacao.titulo}
          onChange={e => aoModificarTitulo(e, e.target.value)}
          error={erroTitulo}
        />
      </Grid>
      <Grid
        item
        md={12}
        xs={12}
      >
        <TextField
          multiline
          rows={4}
          rowsMax={5}
          fullWidth
          variant={'outlined'}
          inputProps={{ maxLength: 1500 }}
          label={'Descrição'}
          helperText={'Fique à vontade para digitar o que for pertinente para essa observação.'}
          value={novaObservacao.descricao}
          onChange={e => aoModificarDescricao(e, e.target.value)}
        />
      </Grid>
      <Grid
        item
        md={12}
        xs={12}
      >
        <Button
          variant={'outlined'}
          margin={'dense'}
          fullWidth
          onClick={e => salvarNovaObservacao(e, novaObservacao)}
        >
          SALVAR
        </Button>
      </Grid>
    </Grid>
  );
}

ModoInsercaoObservacao.propTypes = {
  className: PropTypes.string,
  usuario: PropTypes.object.isRequired,
};

export default ModoInsercaoObservacao;


